









import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import {Prop} from 'vue-property-decorator';

@Component({
  mixins: [BindAttrs]
})
export default class AmetrasAdvancedTimelineButtonTemplate extends Vue {
  @Prop({
    default: ''
  }) label!: string;

  emitClick(event: Event) {
    this.$emit('change', event);
    this.$emit('click', event);
  }

}
